import { render } from "./Directional.vue?vue&type=template&id=0d540fb8&scoped=true"
import script from "./Directional.vue?vue&type=script&lang=js"
export * from "./Directional.vue?vue&type=script&lang=js"

import "./Directional.vue?vue&type=style&index=0&id=0d540fb8&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d540fb8"]])

export default __exports__